import React, { useState, useEffect } from 'react';
import { getSharedFilters, saveSharedFilters } from '../../utils/filterStore';
import axios from 'axios';
import { API_URL as CONFIG_API_URL } from '../../config';
const API_URL = CONFIG_API_URL || 'http://8.141.122.155:3002/api';
import { Clock, TrendingUp, ShoppingBag, BarChart2, Box, Award, Shield, LayoutGrid, Store, Filter, ChevronDown, Check, TrendingDown, Download, FileSpreadsheet, Zap } from 'lucide-react';
import ReactECharts from 'echarts-for-react';
import html2canvas from 'html2canvas';
import * as XLSX from 'xlsx';

const engineLogos = {
  /* INJECTED_MB_PC_LOGOS_v2 */
  '豆包': '/icons/doubao.png',
  '豆包(PC)': '/icons/doubao.png',
  '豆包(MB)': '/icons/doubao.png',
  '豆包（PC）': '/icons/doubao.png',
  '豆包（MB）': '/icons/doubao.png',
  'doubao': '/icons/doubao.png',
  '腾讯元宝(PC)': '/icons/yuanbao.png',
  '腾讯元宝(MB)': '/icons/yuanbao.png',
  '腾讯元宝（PC）': '/icons/yuanbao.png',
  '腾讯元宝（MB）': '/icons/yuanbao.png',
  '通义千问': '/icons/tongyi.png',
  '通义千问(PC)': '/icons/tongyi.png',
  '通义千问(MB)': '/icons/tongyi.png',
  '通义千问（PC）': '/icons/tongyi.png',
  '通义千问（MB）': '/icons/tongyi.png',
  '通义': '/icons/tongyi.png',
  '文心一言': '/icons/wenxin.png',
  '文心一言(PC)': '/icons/wenxin.png',
  '文心一言(MB)': '/icons/wenxin.png',
  'Deepseek': '/icons/deepseek.png',
  'DeepSeek': '/icons/deepseek.png',
  'deepseek': '/icons/deepseek.png',
  'Kimi': '/icons/kimi.png',
  'kimi': '/icons/kimi.png',
  '元宝': '/icons/yuanbao.png',
  '百度AI搜索': '/icons/baidu.png',
  '小红书AI': '/icons/xiaohongshu.png',
  '抖音AI': '/icons/douyin.png',
  '小红书': '/icons/xiaohongshu.png',
  'xhs': '/icons/xiaohongshu.png',
  '微信搜一搜': '/icons/wechat.png',
  '微信': '/icons/wechat.png',
};

export default function CommerceMatrix() {
  const [data, setData] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 20;
  const [loading, setLoading] = useState(true);

  const [openDropdown, setOpenDropdown] = useState(null);
  const filterBarRef = React.useRef(null);
  
  const [filters, setFilters] = useState(() => getSharedFilters({
    time: '最近 7 天',
    customDate: { start: '', end: '' },
    engines: ['全部 AI 引擎']
  }));
  
  useEffect(() => {
    saveSharedFilters(filters);
  }, [filters]);

  const toggleDropdown = (name) => {
    setOpenDropdown(prev => prev === name ? null : name);
  };

  const updateTimeFilter = (val) => {
    setFilters(prev => ({ ...prev, time: val }));
    if (val !== '自定义范围') setOpenDropdown(null);
  };

  const toggleArrayFilter = (key, value, defaultAll) => {
    setFilters(prev => {
      let current = [...prev[key]];
      if (value === defaultAll) return { ...prev, [key]: [defaultAll] };
      current = current.filter(v => v !== defaultAll);
      if (current.includes(value)) {
        current = current.filter(v => v !== value);
        if (current.length === 0) current = [defaultAll];
      } else {
        current.push(value);
      }
      return { ...prev, [key]: current };
    });
  };

  const renderArrayLabel = (arr, defaultAll, prefix = '') => {
    if (arr.includes(defaultAll)) return defaultAll;
    if (arr.length === 1) return prefix + arr[0];
    return prefix + arr[0] + ` 等${arr.length}项`;
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (filterBarRef.current && !filterBarRef.current.contains(event.target)) {
        setOpenDropdown(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  if (loading === "silence_warning") console.log("silent");

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const token = localStorage.getItem('token');
        const headers = token ? { Authorization: `Bearer ${token}` } : {};
        const globalBrand = localStorage.getItem('globalBrand');
        
        
        const engineParam = filters.engines.includes('全部 AI 引擎') ? 'all' : filters.engines.join(',');
        let startDate = undefined;
        let endDate = undefined;
        if (filters.time === '最近 7 天') {
           const d = new Date(); d.setDate(d.getDate() - 7); startDate = d.toISOString(); endDate = new Date().toISOString();
        } else if (filters.time === '最近 30 天') {
           const d = new Date(); d.setDate(d.getDate() - 30); startDate = d.toISOString(); endDate = new Date().toISOString();
        } else if (filters.time === '最近 90 天') {
           const d = new Date(); d.setDate(d.getDate() - 90); startDate = d.toISOString(); endDate = new Date().toISOString();
        } else if (filters.time === '自定义范围') {
           if (filters.customDate.start) startDate = new Date(filters.customDate.start).toISOString();
           if (filters.customDate.end) {
              const end = new Date(filters.customDate.end);
              end.setHours(23,59,59,999);
              endDate = end.toISOString();
           }
        }

        const globalProject = localStorage.getItem('globalProject');
        const res = await axios.get(`${API_URL}/commerce/matrix`, {
          headers,
          params: { 
              brandProjectId: globalBrand,
              geoTaskId: globalProject,
              engines: engineParam,
              startDate,
              endDate
          }
        });
        if (res.data.success) {
          setData(res.data.data);
          setCurrentPage(1);
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    
    fetchData();
    const handleGlobalChange = () => fetchData();
    window.addEventListener('globalFilterChange', handleGlobalChange);
    return () => window.removeEventListener('globalFilterChange', handleGlobalChange);
  }, [filters]);

  const handleExportImage = async () => {
    const contentElement = document.getElementById('report-content');
    if (!contentElement) return;
    try {
      const canvas = await html2canvas(contentElement, { scale: 2, useCORS: true, backgroundColor: document.documentElement.classList.contains('dark') ? '#0f172a' : '#ffffff' });
      const image = canvas.toDataURL('image/png');
      const link = document.createElement('a');
      link.href = image;
      link.download = `商品卡位矩阵_${new Date().toISOString().slice(0, 10)}.png`;
      link.click();
    } catch (error) {
      console.error('Failed to export image', error);
    }
  };

  const handleExportExcel = () => {
    if (!data) return;
    
    // 1. KPI Data
    const kpiSheetData = [
      ['指标名称', '当前值', '环比趋势'],
      ['大盘总展现商品频次', data.summary.totalCards || '-', `${data.summary.totalCardsDiff > 0 ? '+' : ''}${data.summary.totalCardsDiff}%`],
      ['本品霸榜率 (SOV)', `${data.summary.mainBrandSov}%`, `${data.summary.mainBrandSovDiff > 0 ? '+' : ''}${data.summary.mainBrandSovDiff}%`],
      ['官旗承接份额', data.summary.officialAcceptance || '-', `${data.summary.officialAcceptanceDiff > 0 ? '+' : ''}${data.summary.officialAcceptanceDiff}%`],
      ['C店/专营流失份额', data.summary.cStoreLoss || '-', `${data.summary.cStoreLossDiff > 0 ? '+' : ''}${data.summary.cStoreLossDiff}%`],
    ];

    // 2. Trend Data
    const trendSheetData = [
      ['日期', '本品(声量占有率)%']
    ];
    if (data.trendData && data.trendData.dates) {
      data.trendData.dates.forEach((date, i) => {
        trendSheetData.push([date, data.trendData.mainSov[i]]);
      });
    }

    const wsKpi = XLSX.utils.aoa_to_sheet(kpiSheetData);
    const wsTrend = XLSX.utils.aoa_to_sheet(trendSheetData);
    
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, wsKpi, "核心指标");
    XLSX.utils.book_append_sheet(wb, wsTrend, "SOV趋势");
    
    XLSX.writeFile(wb, `商品卡位矩阵数据_${new Date().toISOString().slice(0, 10)}.xlsx`);
  };

  const trendOptions = data && data.trendData ? {
    tooltip: { trigger: 'axis' },
    legend: { data: ['本品(声量占有率)'], textStyle: { color: '#94a3b8' } },
    grid: { left: '3%', right: '4%', bottom: '3%', containLabel: true },
    xAxis: { type: 'category', boundaryGap: false, data: data.trendData.dates, axisLabel: { color: '#94a3b8' } },
    yAxis: { type: 'value', name: 'SOV声量占比 (%)', nameTextStyle: { color: '#94a3b8' }, axisLabel: { color: '#94a3b8' }, splitLine: { lineStyle: { color: '#334155', type: 'dashed' } } },
    series: [
      { name: '本品(声量占有率)', type: 'line', smooth: true, itemStyle: { color: '#3b82f6' }, areaStyle: { color: 'rgba(59, 130, 246, 0.2)' }, data: data.trendData.mainSov },
    ]
  } : {};

  

  

  

  

  return (
    <div className="p-6 space-y-6">
      <div className="flex justify-between items-center mb-2">
        <div>
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white flex items-center gap-2">
            <LayoutGrid className="text-blue-500 w-6 h-6" />商品卡位矩阵 (Commerce Matrix)
          </h1>
          <p className="text-sm text-gray-500 dark:text-slate-400 mt-1">监控各大 AI 引擎的带货直达卡片，洞察品牌防守身位。</p>
        </div>
        <div className="flex items-center gap-3">
          <button 
            className="flex items-center gap-2 px-4 py-2 bg-[#8B84AD] text-white rounded-lg shadow-sm hover:opacity-90 transition-colors text-sm font-medium"
            onClick={handleExportExcel}
          >
            <FileSpreadsheet className="w-4 h-4" />
            导出数据
          </button>
          <button 
            className="flex items-center gap-2 px-4 py-2 bg-[#9EA9DF] text-white rounded-lg shadow-sm hover:opacity-90 transition-colors text-sm font-medium"
            onClick={handleExportImage}
          >
            <Download className="w-4 h-4" />
            导出图片
          </button>
        </div>
      </div>

      <div id="report-content" className="space-y-6">

      
      {/* Quick Engine Shortcuts */}
      <div className="bg-white dark:bg-slate-800/80 backdrop-blur-xl border border-gray-100 dark:border-slate-700/50 rounded-lg p-3 mb-4 flex flex-wrap items-center gap-3 shadow-sm">
        <div className="flex items-center text-sm font-medium text-gray-700 dark:text-slate-300 mr-2">
          <Zap size={16} className="mr-2 text-amber-500 fill-amber-500/20" /> 快捷引擎过滤
        </div>
        
        <button
          onClick={() => setFilters(prev => ({ ...prev, engines: ['全部 AI 引擎'] }))}
          className={`px-4 py-1.5 rounded-full text-sm font-medium transition-all duration-300 border shadow-sm ${filters.engines.includes('全部 AI 引擎') ? 'bg-gradient-to-r from-blue-500 to-blue-600 border-blue-600 text-white shadow-blue-500/25' : 'bg-gray-50 border-gray-200 text-gray-600 hover:bg-gray-100 hover:border-gray-300 dark:bg-slate-800 dark:border-slate-600 dark:text-slate-300 dark:hover:bg-slate-700'}`}
        >
          全部
        </button>

        <button
          onClick={() => setFilters(prev => ({ ...prev, engines: ['豆包(PC)', '豆包(MB)'] }))}
          className={`px-4 py-1.5 rounded-full text-sm font-medium transition-all duration-300 border shadow-sm flex items-center gap-2 ${filters.engines.includes('豆包(PC)') && filters.engines.includes('豆包(MB)') && filters.engines.length === 2 ? 'bg-gradient-to-r from-indigo-500 to-indigo-600 border-indigo-600 text-white shadow-indigo-500/25' : 'bg-gray-50 border-gray-200 text-gray-600 hover:bg-gray-100 hover:border-gray-300 dark:bg-slate-800 dark:border-slate-600 dark:text-slate-300 dark:hover:bg-slate-700'}`}
        >
          <img src="/icons/doubao.png" className="w-4 h-4 rounded-full bg-white" /> 豆包
        </button>

        <button
          onClick={() => setFilters(prev => ({ ...prev, engines: ['腾讯元宝(PC)', '腾讯元宝(MB)'] }))}
          className={`px-4 py-1.5 rounded-full text-sm font-medium transition-all duration-300 border shadow-sm flex items-center gap-2 ${filters.engines.includes('腾讯元宝(PC)') && filters.engines.includes('腾讯元宝(MB)') && filters.engines.length === 2 ? 'bg-gradient-to-r from-indigo-500 to-indigo-600 border-indigo-600 text-white shadow-indigo-500/25' : 'bg-gray-50 border-gray-200 text-gray-600 hover:bg-gray-100 hover:border-gray-300 dark:bg-slate-800 dark:border-slate-600 dark:text-slate-300 dark:hover:bg-slate-700'}`}
        >
          <img src="/icons/yuanbao.png" className="w-4 h-4 rounded-full bg-white p-0.5" /> 元宝
        </button>

        <button
          onClick={() => setFilters(prev => ({ ...prev, engines: ['通义千问(PC)', '通义千问(MB)'] }))}
          className={`px-4 py-1.5 rounded-full text-sm font-medium transition-all duration-300 border shadow-sm flex items-center gap-2 ${filters.engines.includes('通义千问(PC)') && filters.engines.includes('通义千问(MB)') && filters.engines.length === 2 ? 'bg-gradient-to-r from-indigo-500 to-indigo-600 border-indigo-600 text-white shadow-indigo-500/25' : 'bg-gray-50 border-gray-200 text-gray-600 hover:bg-gray-100 hover:border-gray-300 dark:bg-slate-800 dark:border-slate-600 dark:text-slate-300 dark:hover:bg-slate-700'}`}
        >
          <img src="/icons/tongyi.png" className="w-4 h-4 rounded-full bg-white" /> 通义千问
        </button>
      </div>

      {/* Global Filter Bar */}
      <div ref={filterBarRef} className="relative z-30 bg-white dark:bg-slate-800/80 backdrop-blur-xl border border-gray-100 dark:border-slate-700/50 rounded-lg p-3 mb-6 flex flex-wrap items-center gap-3 shadow-sm">
        <div className="flex items-center text-sm font-medium text-gray-700 dark:text-slate-300 mr-2">
          <Filter size={16} className="mr-2 text-blue-500" /> 数据筛选
        </div>
        
        {/* Time Filter */}
        <div className="relative">
          <button 
            onClick={() => toggleDropdown('time')}
            className="flex items-center space-x-2 px-3 py-1.5 bg-gray-50 dark:bg-slate-900/50 border border-gray-200 dark:border-slate-600 rounded-md text-sm text-gray-600 dark:text-slate-300 hover:bg-gray-100 dark:hover:bg-slate-800 transition-colors"
          >
            <Clock className="w-4 h-4 text-gray-400" />
            <span>{filters.time === '自定义范围' && filters.customDate.start ? `${filters.customDate.start} 至 ${filters.customDate.end}` : filters.time}</span>
            <ChevronDown size={14} className={`text-gray-400 transition-transform ${openDropdown === 'time' ? 'rotate-180' : ''}`} />
          </button>
          {openDropdown === 'time' && (
            <div className="absolute top-full left-0 mt-1 w-64 bg-white dark:bg-slate-800 border border-gray-100 dark:border-slate-700 rounded-md shadow-xl z-50 overflow-hidden">
              {['最近 7 天', '最近 30 天', '最近 90 天', '全部时间', '自定义范围'].map(opt => (
                <div key={opt} onClick={() => updateTimeFilter(opt)} className="px-4 py-2 text-sm text-gray-700 dark:text-slate-300 hover:bg-blue-50 dark:hover:bg-slate-700 cursor-pointer flex justify-between items-center">
                  <span>{opt}</span>
                  {filters.time === opt && <Check size={14} className="text-blue-500" />}
                </div>
              ))}
              {filters.time === '自定义范围' && (
                <div className="px-4 py-3 bg-gray-50 dark:bg-slate-900/50 border-t border-gray-100 dark:border-slate-700 space-y-2">
                  <div className="flex items-center justify-between">
                    <span className="text-xs text-gray-500">开始</span>
                    <input type="date" value={filters.customDate.start} onChange={(e) => setFilters(p => ({...p, customDate: {...p.customDate, start: e.target.value}}))} className="text-xs border border-gray-300 dark:border-slate-600 rounded px-2 py-1 bg-white dark:bg-slate-800 text-gray-700 dark:text-slate-300" />
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-xs text-gray-500">结束</span>
                    <input type="date" value={filters.customDate.end} onChange={(e) => setFilters(p => ({...p, customDate: {...p.customDate, end: e.target.value}}))} className="text-xs border border-gray-300 dark:border-slate-600 rounded px-2 py-1 bg-white dark:bg-slate-800 text-gray-700 dark:text-slate-300" />
                  </div>
                  <button onClick={() => setOpenDropdown(null)} className="w-full mt-2 bg-blue-500 text-white text-xs py-1.5 rounded hover:bg-blue-600 transition">确定</button>
                </div>
              )}
            </div>
          )}
        </div>

        {/* Engine Filter */}
        <div className="relative">
          <button 
            onClick={() => toggleDropdown('engines')}
            className="flex items-center space-x-2 px-3 py-1.5 bg-gray-50 dark:bg-slate-900/50 border border-gray-200 dark:border-slate-600 rounded-md text-sm text-gray-600 dark:text-slate-300 hover:bg-gray-100 dark:hover:bg-slate-800 transition-colors"
          >
            <span>{renderArrayLabel(filters.engines, '全部 AI 引擎')}</span>
            <ChevronDown size={14} className={`text-gray-400 transition-transform ${openDropdown === 'engines' ? 'rotate-180' : ''}`} />
          </button>
          {openDropdown === 'engines' && (
            <div className="absolute top-full left-0 mt-1 w-48 bg-white dark:bg-slate-800 border border-gray-100 dark:border-slate-700 rounded-md shadow-xl z-50 overflow-hidden">
              <div className="py-1">
                <div onClick={() => toggleArrayFilter('engines', '全部 AI 引擎', '全部 AI 引擎')} className="px-4 py-2 text-sm text-gray-700 dark:text-slate-300 hover:bg-blue-50 dark:hover:bg-slate-700 cursor-pointer flex items-center space-x-2 font-medium">
                  <input type="checkbox" checked={filters.engines.includes('全部 AI 引擎')} readOnly className="rounded border-gray-300 text-blue-600 focus:ring-blue-500" />
                  <span>全部 AI 引擎</span>
                </div>
                
                {['Kimi', 'DeepSeek', '豆包', '文心一言', '腾讯元宝', '通义千问', '小红书AI', '抖音AI', '百度AI搜索'].map(opt => {
                  const isDisabled = opt === '百度AI搜索';
                  if (opt === '豆包' || opt === '腾讯元宝' || opt === '通义千问') {
                     const baseName = opt;
                     const pcName = baseName + '(PC)';
                     const mbName = baseName + '(MB)';
                     const isMBDisabled = false; 
                     
                     return (
                        <div key={opt} className="px-4 py-2 flex flex-col gap-2 border-b border-gray-50 dark:border-slate-800/50 hover:bg-gray-50/50 dark:hover:bg-slate-700/50">
                           <div className="flex items-center gap-2 text-sm text-gray-700 dark:text-slate-300">
                              {engineLogos[baseName] && <img src={engineLogos[baseName]} alt={baseName} className="w-4 h-4 rounded-sm object-contain" />}
                              <span>{baseName}</span>
                           </div>
                           <div className="flex gap-2 pl-6">
                              <div onClick={(e) => { e.stopPropagation(); toggleArrayFilter('engines', pcName, '全部 AI 引擎') }} className={`flex items-center gap-1.5 px-2 py-1 rounded text-xs cursor-pointer transition-colors border ${filters.engines.includes(pcName) ? 'bg-blue-50 border-blue-200 text-blue-700 dark:bg-blue-900/30 dark:border-blue-800 dark:text-blue-400' : 'bg-white border-gray-200 text-gray-600 hover:bg-gray-50 dark:bg-slate-800 dark:border-slate-600 dark:text-slate-300 dark:hover:bg-slate-700'}`}>
                                 <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect><line x1="8" y1="21" x2="16" y2="21"></line><line x1="12" y1="17" x2="12" y2="21"></line></svg>
                                 <span>PC</span>
                              </div>
                              <div onClick={(e) => { 
                                  e.stopPropagation(); 
                                  if (!isMBDisabled) toggleArrayFilter('engines', mbName, '全部 AI 引擎'); 
                                }} 
                                className={`flex items-center gap-1.5 px-2 py-1 rounded text-xs transition-colors border ${isMBDisabled ? 'bg-gray-100 border-gray-200 text-gray-400 cursor-not-allowed dark:bg-slate-800/50 dark:border-slate-700 dark:text-slate-500' : (filters.engines.includes(mbName) ? 'bg-blue-50 border-blue-200 text-blue-700 cursor-pointer dark:bg-blue-900/30 dark:border-blue-800 dark:text-blue-400' : 'bg-white border-gray-200 text-gray-600 cursor-pointer hover:bg-gray-50 dark:bg-slate-800 dark:border-slate-600 dark:text-slate-300 dark:hover:bg-slate-700')}`}>
                                 <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><rect x="5" y="2" width="14" height="20" rx="2" ry="2"></rect><line x1="12" y1="18" x2="12.01" y2="18"></line></svg>
                                 <span>MB</span>
                              </div>
                           </div>
                        </div>
                     );
                  }
                  return (
                  <div 
                    key={opt} 
                    onClick={(e) => { e.stopPropagation(); if (!isDisabled) toggleArrayFilter('engines', opt, '全部 AI 引擎') }} 
                    className={`px-4 py-2 text-sm flex items-center space-x-2 ${isDisabled ? 'opacity-50 cursor-not-allowed bg-gray-50 dark:bg-slate-900 text-gray-500' : 'text-gray-700 dark:text-slate-300 hover:bg-blue-50 dark:hover:bg-slate-700 cursor-pointer'}`}
                    title={isDisabled ? "暂未开放" : ""}
                  >
                    <input type="checkbox" checked={filters.engines.includes(opt)} disabled={isDisabled} readOnly className="rounded border-gray-300 text-blue-600 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed" />
                    {engineLogos[opt] && <img src={engineLogos[opt]} alt={opt} className="w-4 h-4 rounded-sm object-contain" />}
                    <span>{opt}{isDisabled ? ' (暂未开放)' : ''}</span>
                  </div>
                  );
                })}

              </div>
            </div>
          )}
        </div>
      </div>

      {/* KPI Cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <div className="bg-white dark:bg-slate-800 rounded-xl p-5 border border-gray-100 dark:border-slate-700 shadow-sm">
          <p className="text-sm text-gray-500 dark:text-slate-400">大盘总展现商品频次</p>
          <h4 className="text-2xl font-bold text-gray-900 dark:text-white mt-1">{data ? data.summary.totalCards.toLocaleString() : "..."}</h4>
          {data && (
            <span className={`text-sm flex items-center mt-2 ${data.summary.totalCardsDiff >= 0 ? 'text-emerald-500' : 'text-rose-500'}`}>
              {data.summary.totalCardsDiff >= 0 ? <TrendingUp className="w-3 h-3 mr-1"/> : <TrendingDown className="w-3 h-3 mr-1"/>}
              较上周期 {data.summary.totalCardsDiff > 0 ? '+' : ''}{data.summary.totalCardsDiff}%
            </span>
          )}
        </div>
        <div className="bg-white dark:bg-slate-800 rounded-xl p-5 border border-gray-100 dark:border-slate-700 shadow-sm">
          <p className="text-sm text-gray-500 dark:text-slate-400">本品霸榜率 (SOV)</p>
          <h4 className="text-2xl font-bold text-blue-500 mt-1">{data ? data.summary.mainBrandSov + "%" : "..."}</h4>
          {data && (
            <span className={`text-sm flex items-center mt-2 ${data.summary.mainBrandSovDiff >= 0 ? 'text-emerald-500' : 'text-rose-500'}`}>
              {data.summary.mainBrandSovDiff >= 0 ? <TrendingUp className="w-3 h-3 mr-1"/> : <TrendingDown className="w-3 h-3 mr-1"/>}
              较上周期 {data.summary.mainBrandSovDiff > 0 ? '+' : ''}{data.summary.mainBrandSovDiff}%
            </span>
          )}
        </div>
        <div className="bg-white dark:bg-slate-800 rounded-xl p-5 border border-gray-100 dark:border-slate-700 shadow-sm">
          <p className="text-sm text-gray-500 dark:text-slate-400">官旗承接份额</p>
          <h4 className="text-2xl font-bold text-amber-500 mt-1">{data ? data.summary.officialAcceptance : "..."}</h4>
          {data && (
            <span className={`text-sm flex items-center mt-2 ${data.summary.officialAcceptanceDiff >= 0 ? 'text-emerald-500' : 'text-rose-500'}`}>
              {data.summary.officialAcceptanceDiff >= 0 ? <TrendingUp className="w-3 h-3 mr-1"/> : <TrendingDown className="w-3 h-3 mr-1"/>}
              较上周期 {data.summary.officialAcceptanceDiff > 0 ? '+' : ''}{data.summary.officialAcceptanceDiff}%
            </span>
          )}
        </div>
        <div className="bg-white dark:bg-slate-800 rounded-xl p-5 border border-gray-100 dark:border-slate-700 shadow-sm">
          <p className="text-sm text-gray-500 dark:text-slate-400">C店/专营流失份额</p>
          <h4 className="text-2xl font-bold text-gray-900 dark:text-white mt-1">{data ? data.summary.cStoreLoss : "..."}</h4>
          {data && (
            <span className={`text-sm flex items-center mt-2 ${data.summary.cStoreLossDiff <= 0 ? 'text-emerald-500' : 'text-rose-500'}`}>
              {data.summary.cStoreLossDiff <= 0 ? <TrendingDown className="w-3 h-3 mr-1"/> : <TrendingUp className="w-3 h-3 mr-1"/>}
              较上周期 {data.summary.cStoreLossDiff > 0 ? '+' : ''}{data.summary.cStoreLossDiff}%
            </span>
          )}
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      {/* Row 1: Trend Chart */}
      <div className="bg-white dark:bg-slate-800 rounded-xl border border-gray-100 dark:border-slate-700 shadow-sm p-5">
        <h3 className="text-base font-bold text-gray-900 dark:text-white mb-4">大盘声量时序趋势 (SOV Trend)</h3>
        <div className="h-[300px] w-full">{data && <ReactECharts option={trendOptions} style={{ height: '100%', width: '100%' }} />}</div>
      </div>

      {/* Row 2: Top Stores */}
      <div className="bg-white dark:bg-slate-800 rounded-xl border border-gray-100 dark:border-slate-700 shadow-sm p-5 h-[372px] overflow-hidden flex flex-col">
          <h3 className="text-base font-bold text-gray-900 dark:text-white mb-4 flex items-center gap-2"><Shield className="w-4 h-4 text-emerald-500"/>获流阵地 (店铺) 分布</h3>
          <div className="overflow-x-auto">
            <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
              <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-slate-700 dark:text-gray-400">
                <tr>
                  <th className="px-4 py-3">排名</th>
                  <th className="px-4 py-3">店铺名称</th>
                  <th className="px-4 py-3 text-center">推荐次数</th>
                  <th className="px-4 py-3 text-right">流量份额 (SOV)</th>
                </tr>
              </thead>
              <tbody>
                {(() => {
                    const storeAgg = {};
                    let totalRecommends = 0;
                    (data?.productCards || []).forEach(c => {
                        const m = c.merchant || '未知店铺';
                        if (!storeAgg[m]) storeAgg[m] = { name: m, type: '其他', count: 0 };
                        if (m.includes('旗舰店')) storeAgg[m].type = '官旗';
                        else if (m.includes('自营')) storeAgg[m].type = '自营';
                        else if (m.includes('专营') || m.includes('C店')) storeAgg[m].type = 'C店/专营';
                        storeAgg[m].count += c.recommendHeat;
                        totalRecommends += c.recommendHeat;
                    });
                    
                    const sortedStores = Object.values(storeAgg)
                        .sort((a, b) => b.count - a.count)
                        .slice(0, 10);

                    return sortedStores.map((s, i) => (
                      <tr key={i} className="border-b dark:border-slate-700 hover:bg-gray-50 dark:hover:bg-slate-700/50">
                        <td className="px-4 py-3 font-bold text-gray-900 dark:text-white">{i + 1}</td>
                        <td className="px-4 py-3 truncate max-w-[200px]">{s.name} <span className={`ml-2 px-2 py-0.5 rounded-full text-[10px] ${s.type==='官旗'?'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-400':'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-400'}`}>{s.type}</span></td>
                        <td className="px-4 py-3 text-center font-bold text-gray-900 dark:text-white">{s.count}</td>
                        <td className="px-4 py-3 text-right font-medium text-blue-500">
                           {totalRecommends > 0 ? ((s.count / totalRecommends) * 100).toFixed(1) + '%' : '0%'}
                        </td>
                      </tr>
                    ));
                })()}
              </tbody>
            </table>
          </div>
      </div>
      </div>

      {/* Row 3: Product Grid */}
      <div className="bg-white dark:bg-slate-800 rounded-xl border border-gray-100 dark:border-slate-700 shadow-sm p-5">
        <h3 className="text-base font-bold text-gray-900 dark:text-white mb-4 flex items-center gap-2"><ShoppingBag className="w-4 h-4 text-blue-500" />大模型带货热销榜单 (Live Snapshot)</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {(data?.productCards || []).slice((currentPage - 1) * pageSize, currentPage * pageSize).map((card, index) => {
            const idx = (currentPage - 1) * pageSize + index;
            return (
            <div key={idx} className="bg-gray-50 dark:bg-slate-900 border border-gray-200 dark:border-slate-700 rounded-xl overflow-hidden hover:border-blue-500/50 hover:shadow-md transition-all group relative flex flex-col">
              <div className="absolute top-2 right-2 z-10 bg-black/60 backdrop-blur-sm text-white text-[10px] px-2 py-0.5 rounded-full border border-white/20 flex items-center gap-1">
                <span className={`w-1.5 h-1.5 rounded-full ${card.engine.includes('豆包')?'bg-blue-400':'bg-violet-400'}`}></span> 首发: {card.engine}
              </div>
              <div className={`absolute top-0 left-0 z-10 text-white text-xs font-bold px-3 py-1 rounded-br-lg ${idx === 0 ? 'bg-red-500' : idx === 1 ? 'bg-orange-500' : idx === 2 ? 'bg-amber-500' : 'bg-slate-600'}`}>
                TOP {idx + 1}
              </div>
              <div className="h-48 overflow-hidden relative flex-shrink-0 bg-white dark:bg-slate-800">
                {card.imageUrl ? (
                   (card.imageUrl.includes('jd.com') || card.imageUrl.includes('taobao.com') || card.imageUrl.includes('tmall.com')) ? (
                      <a href={card.imageUrl} target="_blank" rel="noopener noreferrer" className="w-full h-full flex flex-col items-center justify-center bg-gray-100 dark:bg-slate-700 hover:bg-gray-200 dark:hover:bg-slate-600 transition-colors cursor-pointer text-gray-500 hover:text-blue-500">
                         <ShoppingBag className="w-10 h-10 mb-2 opacity-40" />
                         <span className="text-xs font-medium">点击直达电商查看</span>
                      </a>
                   ) : (
                      <img src={card.imageUrl} referrerPolicy="no-referrer" alt={card.productName} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                   )
                ) : (
                   <div className="w-full h-full flex items-center justify-center bg-gray-100 dark:bg-slate-700 text-gray-400 text-xs"><ShoppingBag className="w-8 h-8 opacity-20 mr-2" /> 暂无配图</div>
                )}
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-slate-900 to-transparent p-3 pt-12 pointer-events-none">
                  <p className="text-white text-xs font-medium opacity-90 line-clamp-1">{card.merchant}</p>
                </div>
              </div>
              <div className="p-4 flex flex-col flex-grow">
                <h4 className="text-sm font-bold text-gray-900 dark:text-white line-clamp-2 min-h-[40px] mb-1" title={card.productName}>{card.productName}</h4>
                {(card.price || card.sales) && (
                    <div className="mb-2 flex items-center justify-between">
                        {card.price && (
                            <div className="flex items-center">
                                <span className="text-xs text-red-500 font-bold mr-1">¥</span>
                                <span className="text-lg font-bold text-red-500 leading-none">{String(card.price).replace('¥', '').replace('￥', '')}</span>
                            </div>
                        )}
                        {card.sales && (
                            <span className="text-xs text-gray-500 bg-gray-100 dark:bg-slate-800 px-2 py-0.5 rounded-full">{card.sales}</span>
                        )}
                    </div>
                )}
                <p className="text-xs text-gray-500 dark:text-slate-400 mb-4 line-clamp-2" title={card.details}>{card.details}</p>
                <div className="mt-auto pt-3 border-t border-gray-200 dark:border-slate-700/50 flex justify-between items-center">
                  <div>
                      <p className="text-[10px] text-gray-500 uppercase tracking-wider mb-0.5">大模型展示频次</p>
                      <p className="text-xl font-bold text-blue-500 leading-none">{card.recommendHeat}</p>
                  </div>
                  <span className={`px-2 py-1 rounded text-[10px] font-medium ${card.isMainBrand ? 'bg-blue-100 text-blue-700 dark:bg-blue-900/50 dark:text-blue-400' : 'bg-gray-200 text-gray-600 dark:bg-slate-700 dark:text-slate-300'}`}>
                    {card.isMainBrand ? '本品' : '竞品'}
                  </span>
                </div>
              </div>
            </div>
          );
          })}
        
        </div>
        
        {/* Pagination Controls */}
        {data?.productCards && data.productCards.length > pageSize && (
            <div className="mt-6 flex items-center justify-between border-t border-gray-100 dark:border-slate-700/50 pt-4">
                <span className="text-sm text-gray-500 dark:text-slate-400">
                    共 {data.productCards.length} 款商品
                </span>
                <div className="flex gap-2">
                    <button 
                        onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
                        disabled={currentPage === 1}
                        className="px-3 py-1.5 text-sm rounded bg-gray-50 dark:bg-slate-900 text-gray-700 dark:text-slate-300 border border-gray-200 dark:border-slate-700 disabled:opacity-50 hover:bg-gray-100 dark:hover:bg-slate-800 transition-colors"
                    >
                        上一页
                    </button>
                    <span className="px-3 py-1.5 text-sm text-gray-700 dark:text-slate-300">
                        {currentPage} / {Math.ceil(data.productCards.length / pageSize)}
                    </span>
                    <button 
                        onClick={() => setCurrentPage(p => Math.min(Math.ceil(data.productCards.length / pageSize), p + 1))}
                        disabled={currentPage >= Math.ceil(data.productCards.length / pageSize)}
                        className="px-3 py-1.5 text-sm rounded bg-gray-50 dark:bg-slate-900 text-gray-700 dark:text-slate-300 border border-gray-200 dark:border-slate-700 disabled:opacity-50 hover:bg-gray-100 dark:hover:bg-slate-800 transition-colors"
                    >
                        下一页
                    </button>
                </div>
            </div>
        )}
      </div>
      </div>
    </div>
  );
}
